<ion-header class="m-operation-or-reject-reason-header">
  <ion-row class="m-operation-or-reject-reason-header__content ion-justify-content-between">
    <ion-col size="8" class="ion-no-padding">
      <div *ngIf="isOperationSelection && !isRecentDefectiveSelection">
        {{ 'operation_or_reject_reason_selection.defectiveHeading' | translate }}
      </div>
      <div *ngIf="!isOperationSelection && !isRecentDefectiveSelection">
        {{ 'operation_or_reject_reason_selection.rejectHeading' | translate }}
      </div>
      <div *ngIf="isRecentDefectiveSelection">
        {{ 'operation_or_reject_reason_selection.recentDefectivesHeading' | translate }}
      </div>
    </ion-col>
    <ion-col size="3" class="ion-no-padding">
      <div class="selected-count">
        {{ 'input_app_common.selected' | translate }}: {{ selectedOperationOrRejectReasonList.length }}
      </div>
    </ion-col>
  </ion-row>
</ion-header>
<ion-content class="m-operation-or-reject-reason-content">
  <div class="m-operation-or-reject-reason-content__container">
    <div class="selected-bctx">
      <monorepo-bctx-header [bctxHeader]="bctxHeader" [background]="'rgba(238,238,239,.5)'"></monorepo-bctx-header>
    </div>
    <div class="operation-reject-reason-list">
      <ion-row class="operation-reject-reason-list__heading ion-justify-content-between">
        <ion-col *ngIf="isOperationSelection && !isRecentDefectiveSelection" size="5" class="ion-no-padding">
          {{ 'operation_or_reject_reason_selection.selectOperations' | translate }}
        </ion-col>
        <ion-col *ngIf="!isOperationSelection && !isRecentDefectiveSelection" size="5" class="ion-no-padding">
          {{ 'operation_or_reject_reason_selection.selectRejectList' | translate }}
        </ion-col>
        <ion-col *ngIf="isRecentDefectiveSelection" size="5" class="ion-no-padding">
          {{ 'operation_or_reject_reason_selection.operationsAndIssues' | translate }}
        </ion-col>
        <ion-col *ngIf="!isRecentDefectiveSelection" size="5" class="ion-no-padding filter" (click)="onViewAllClick()">
          {{ 'input_app_common.viewAll' | translate }}
        </ion-col>
      </ion-row>
      <monorepo-multi-select
        [type]="isRecentDefectiveSelection ? 'OPERATION_AND_DEFECT' : 'OPERATION_OR_DEFECT'"
        [lists]="operationOrRejectReasonList"
        [preSelectedList]="selectedOperationOrRejectReasonList"
        (selectedList)="handleOperationOrRejectReasonSelection($event)"
        [enableSearch]="true"
      ></monorepo-multi-select>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-row class="m-operation-or-reject-reason-footer ion-justify-content-between">
    <ion-col sizeLg="2" sizeMd="4" class="ion-no-padding">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.clearAll' | translate"
        (clickEvent)="handleClearAll()"
      ></ui-custom-button
    ></ion-col>
    <ion-col sizeLg="4" sizeMd="6" class="ion-no-padding" style="text-align: end">
      <ui-custom-button
        *ngIf="isImageCapturingEnabled"
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.addPhoto' | translate"
        style="margin-right: 16px"
        (clickEvent)="openCamera()"
      ></ui-custom-button>
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.cancel' | translate"
        (clickEvent)="handleCancel()"
        style="margin-right: 16px"
      ></ui-custom-button>
      <ui-custom-button
        [buttonHeight]="'56px'"
        [btnTxt]="isOperationSelection ? ('input_app_common.next' | translate) : ('input_app_common.done' | translate)"
        (clickEvent)="handleNextOrDone()"
        [isDisabled]="!operationOrRejectReasonList.length"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-footer>
